module.exports = __webpack_public_path__ + "main-line-4.svg?985b2657b4fa84c176984c402d8022c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main-line-4.svg
// module id = 425
// module chunks = 0